import { render, staticRenderFns } from "./StudentGroupSettings.vue?vue&type=template&id=21d1339a&"
import script from "./StudentGroupSettings.vue?vue&type=script&lang=js&"
export * from "./StudentGroupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports